import { message } from 'antd';
import { sendPost } from 'api/axios';
import images from 'assets/images-base';
import { formatUrl } from 'helper';
import { REGEX_VIDEO } from 'helper/regex';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { PluginProps } from 'react-markdown-editor-lite';
import { UploadIcon, UploadStyle } from './uploadVideoStyle';
import { storeSetIsLoadingCreatePost } from 'store/create-post-reducer';
import { useDispatch } from 'react-redux';

const uploadFile = async (file: any) => {
  const data = new FormData();
  data.append('file', file);
  data.append('type', '1');
  const res = await sendPost(`/upload-file`, data);
  return formatUrl(res?.data?.url_file);
};

const Translate: React.FC<{ text: string }> = ({ text }) => {
  const { t } = useTranslation();
  return <>{t(text)}</>;
};

const UploadVideo = (props: PluginProps) => {
  const dispatch = useDispatch();

  const onUploadFile = (options: any) => {
    const file = options?.file;
    if (file.size / 1024 / 1024 >= 20) {
      message.error(<Translate text="createPost.uploadMax" />);
      return;
    }

    if (!REGEX_VIDEO.test(file.type)) {
      message.error(<Translate text="createPost.errorUploadFile" />);
      return;
    }

    dispatch(storeSetIsLoadingCreatePost(true));

    uploadFile(options?.file)
      .then((url) => {
        props.editor.insertText(`<video><source src=${url} type=${file.type}></video>`, true);
        dispatch(storeSetIsLoadingCreatePost(false));
      })
      .catch(() => {
        dispatch(storeSetIsLoadingCreatePost(false));
        message.error(<Translate text="editor.errorSystem" />);
      });
  };

  return (
    <UploadStyle accept=".mp4" customRequest={onUploadFile} fileList={[]}>
      <UploadIcon src={images.createPost.UpLoadFileIcon} />
    </UploadStyle>
  );
};

UploadVideo.defaultConfig = {
  start: 0,
};
UploadVideo.align = 'left';
UploadVideo.pluginName = 'upload-video';

export default UploadVideo;
